<bizz-modal  modalSize="xs" title="PropertyChanged" [contentTemplate]="contentTemplateRef"></bizz-modal>

<ng-template #contentTemplateRef>
    <div class="modal-content">
        <p class="mb-2 inline-block text-sm text-default">
            {{auditLogItem.Name}} {{'PropertyHasBeenChangedTo' | translate}} {{auditLogItem.NewValue}}.</p>
    </div>
</ng-template>